import React, { useState } from 'react'
import { Card, CardBody, Col, Form, FormGroup, Input, Label } from 'reactstrap';
import DataTable, { TableColumn } from 'react-data-table-component';
import CommonCardHeader from '../../Utils/CommonComponents/CommonCardHeader';
import FilterComponent from '../../Components/Tables/DataTables/Common/FilterComponent';

interface TableProps<T> {
    title: string;
    tableColumns: TableColumn<T>[];
    data: T[];
    filterKeys?: (keyof T)[];
}

export default function Table<T>({ title, tableColumns, data, filterKeys}: TableProps<T>) {
    const [filterText, setFilterText] = useState('');
    // const filteredItems = data.filter((item:any) =>
    //     Object.values(item).some((value) =>
    //       value?.toString().toLowerCase().includes(filterText.toLowerCase())
    //     )
    // );

    // Helper to flatten nested object values into a string
    function flattenValues(obj: any): string[] {
        let values: string[] = [];

        function recurse(value: any) {
            if (Array.isArray(value)) {
                value.forEach(recurse); // Recurse into array elements
            } else if (typeof value === 'object' && value !== null) {
                for (const key in value) {
                    recurse(value[key]); // Recurse into object properties
                }
            } else if (value !== undefined && value !== null) {
                values.push(value.toString().toLowerCase().trim());
            }
        }

        recurse(obj);
        return values;
    }

    // const filteredItems = data.filter((item) => {
    //     const flattened = flattenValues(item);
    //     return flattened.some((val) => val.includes(filterText.toLowerCase()));
    // });

    const normalizedFilter = filterText.toLowerCase().trim();

    const filteredItems = data.filter((item) => {
        if (filterKeys?.length) {
            return filterKeys.some(key => {
                const flattened = flattenValues(item[key]);
                return flattened.some((val) => val.includes(normalizedFilter));
            });
        }
        const flattened = flattenValues(item);
        return flattened.some((val) => val.includes(normalizedFilter));
    });

    return (
        <Col sm={12}>
            <Card>
                <CommonCardHeader headClass='pb-0 card-no-border' titleClass='mb-3' title={title} />
                <CardBody>
                    <FilterComponent
                        onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                        filterText={filterText}
                    />
                    <div className="table-responsive">
                        <DataTable data={filteredItems} columns={tableColumns} pagination highlightOnHover striped className="display"
                            paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
                        // paginationPerPage={10}
                        />
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}